import React, { Component } from "react";
import Wix from "Wix";
import DriveItemList from "../driveItemList/DriveItemList";
import Loader from "../loading/Loader";
import EmptyState from "../emptyState/EmptyState"
//import { Scrollbars } from 'react-custom-scrollbars';
import ColoredScrollbars from '../customScrollbars/CustomScrollbars';
//import EditorError from "../editorError/EditorError";
import { injectIntl } from 'react-intl';

import "./WrapperDriveItemList.scss";

class WrapperDriveItemList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileItems: props.fileItems,
      folderItems: props.folderItems,
      displayOwner: true,
      displayLastModified: true,
      sortBy: props.sortBy
    };
  } 

  componentWillReceiveProps(newProps) {
    this.setState({
      fileItems: newProps.fileItems,
      folderItems: newProps.folderItems,
      sortBy: newProps.sortBy
    });
  }

  updateState(data) {
    if (data) {
      if (
        (data.displayOwner === false || data.displayOwner === true) &&
        data.displayOwner !== this.state.displayOwner
      )
        this.setState({ displayOwner: data.displayOwner });
      if (
        (data.displayLastModified === false ||
          data.displayLastModified === true) &&
        data.displayLastModified !== this.state.displayLastModified
      )
        this.setState({ displayLastModified: data.displayLastModified });
    }
  }

  componentDidMount() {
    Wix.Styles.getStyleParams(style => {
      this.updateState(style.booleans);
    });

    Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, style => {
      this.updateState(style.booleans);
    });
  }

  render() {
    let heightScroll = Wix.Utils.getDeviceType() == "mobile" ? "calc(100vh - 50px)":"calc(100vh - 123px)" ;
    return (
      <div className="list-view">
      { this.props.searchEvent || this.state.folderItems.length || this.state.fileItems.length ?
        <div className="item-title">

          <div className={!this.state.displayOwner || !this.state.displayLastModified ? "name-list name-list-2": "name-list"} onClick={() => this.props.SortByParam('Name')}>
          <div>{this.props.intl.formatMessage({id: 'widget.name'})}</div>
            <div className="sortArrowIcon" >
           {this.state.sortBy == "2" ? 
                 this.props.sortAsc ?
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
                    <g  className="fill-stroke" fill="none" fillRule="evenodd">
                        <path d="M1.229 4L5 .229 8.771 4M5 .408v10.666"/>
                    </g>
                  </svg> :
                  <div  className="asc" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
                    <g  className="fill-stroke" fill="none" fillRule="evenodd">
                        <path d="M1.229 4L5 .229 8.771 4M5 .408v10.666"/>
                    </g>
                  </svg>
                </div>
             :
              null}  
          </div>
          </div>

           {this.state.displayOwner ? 
             <div className={!this.state.displayLastModified ? "owner-list owner-list-2": "owner-list"}  onClick={() => this.props.SortByParam('Owner')} > 
                  <div>{this.props.intl.formatMessage({id: 'widget.owner'})}</div>
          <div className="sortArrowIcon" >
              {this.state.sortBy == "3" ? 
                 this.props.sortAsc ?
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
                    <g  className="fill-stroke" fill="none" fillRule="evenodd">
                        <path d="M1.229 4L5 .229 8.771 4M5 .408v10.666"/>
                    </g>
                  </svg> :
                  <div  className="asc" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
                    <g  className="fill-stroke" fill="none" fillRule="evenodd">
                        <path d="M1.229 4L5 .229 8.771 4M5 .408v10.666"/>
                    </g>
                  </svg>
                </div>
             :
              null}  
          </div>
                  {/* <div className={ this.state.sortBy == "sortOwner" ? this.props.sortAsc ? "sortArrowIcon": "sortArrowIcon asc" : ""}  /> */}
            </div>  
             :
             <div/>
             } 
         {this.state.displayLastModified ?
          <div className="last-modified" onClick={() => this.props.SortByParam('Date')} >
                <div>{this.props.intl.formatMessage({id: 'widget.last_modified'})} </div>
                <div className="sortArrowIcon" >
              {this.state.sortBy == "1" ? 
                 this.props.sortAsc ?
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
                    <g  className="fill-stroke" fill="none" fillRule="evenodd">
                        <path d="M1.229 4L5 .229 8.771 4M5 .408v10.666"/>
                    </g>
                  </svg> :
                  <div  className="asc" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
                    <g  className="fill-stroke" fill="none" fillRule="evenodd">
                        <path d="M1.229 4L5 .229 8.771 4M5 .408v10.666"/>
                    </g>
                  </svg>
                </div>
             :
              null}  
          </div> 
                {/* <div className={ this.state.sortBy == "sortDate" ? this.props.sortAsc ? "sortArrowIcon": "sortArrowIcon asc" : ""} /> */}
          </div>
           :  <div/>
          }
        </div>
      : null
      }
        <hr  className="divider-top divider-top-menu"/>
        {
          !this.props.searchEvent && (this.state.folderItems.length || this.state.fileItems.length) ? (
            <ColoredScrollbars style={{height: heightScroll, width: "100%"}}>       
              <div className="items">
                {this.state.folderItems.map(item => {
                  return (
                    <DriveItemList
                      key={item.id}
                      item={item}
                      openFolder={() => this.props.openFolder(item)}/>
                  );
                })}
                {this.state.fileItems.map(item => {
                  return (
                    <DriveItemList
                      key={item.id}
                      item={item}
                      openFolder={() => this.props.openFolder(item)}
                    />
                  );
                })}
              </div>
          </ColoredScrollbars>
        ) : 
        this.props.SearchSignleFile && !this.props.searchEvent ? 
          <EmptyState searchMode={true} folder={this.props.folder} openFolder={item => this.props.openFolder(item)}/> :
          this.props.emptyFolder ? 
            <EmptyState searchMode={false} /> :
            this.props.SearchSignleFile?
            <Loader message={this.props.intl.formatMessage({id: 'widget.searchingForResult'})}     /> 
            :
             <Loader /> 
      }
      </div>
    );
  }
}

export default injectIntl(WrapperDriveItemList);



// WEBPACK FOOTER //
// ./src/widget/components/wrapperDriveItemList/WrapperDriveItemList.js